import 'core-js/shim';
import 'font-awesome/css/font-awesome.css';
import * as Moment from 'moment';
import React from 'react';
import { render } from 'react-dom';
import App from './app';
import './favicon.ico';
import './raven';
import './styles.scss';

Moment.locale('en-gb');

const element = document.getElementById('app');

if (process.env.NODE_ENV === 'development') {
  const AppContainer = require('react-hot-loader').AppContainer;

  render(
    <AppContainer>
      <App />
    </AppContainer>, element,
  );

  // Hot Module Replacement API
  if (module.hot) {
    module.hot.accept('./app', () => {
      const NextApp = require('./app').default;

      render(
        <AppContainer>
          <NextApp />
        </AppContainer>,
        element,
      );
    });
  }
} else {
  render(<App />, element);
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/index.js